<div class="relative flex">
  <!-- desktop sidebar -->
  <aside
    class="sidebar hidden lg:block w-56 bg-dc-navy min-h-screen transition-all duration-300 relative"
    [class.collapsed]="collapsed"
  >
    <div class="bg-pattern flex flex-col h-full">
      <ul class="flex-1 mb-9" id="sidebar">
        @for (menu of menus; track menu) {
          @if (menu.active) {
            <li
              routerLinkActive="active-menu"
              [routerLinkActiveOptions]="{ exact: false }"
            >
              <a
                [routerLink]="menu.key === 'MENU_BUSINESS_GROUP' ? null : '/' + menu.route"
                class="side-menu-item menu-text-icon flex items-center"
                [attr.data-label]="menu.key | translate"
                (click)="collapseSidebar(menu.key, $event)"
              >
                <img [src]="getIconPath(menu.icon)" class="ltr:mr-3 rtl:ml-3" />
                <span class="label">{{ menu.key | translate }}</span>
              </a>
            </li>
          }
        }
      </ul>

      <!-- bottom-fixed block -->
      <div
        class="mt-auto border-t border-dc-dark-blue px-5 py-4 text-white text-sm"
      >
        <!-- Chat link -->
        @if (flags.chatEnabled) {
          <a
            class="flex items-center gap-2 mb-4"
            [attr.data-label]="'CHAT_WITH_US' | translate"
            (click)="onChatWithUs($event)"
          >
            <img [src]="getIconPath('svg/comment.svg')" />
            <span class="label">{{ "CHAT_WITH_US" | translate }}</span>
          </a>

          <a
            class="flex items-center gap-2 mb-4"
            href="https://wa.me/9718002426237"
            target="_blank"
            rel="noopener noreferrer"
            [attr.data-label]="'CHAT_ON_WHATSAPP' | translate"
          >
            <img [src]="getIconPath('svg/whatsapp.svg')" width="24" />
            <span class="label">{{ "CHAT_ON_WHATSAPP" | translate }}</span>
          </a>

          <a
            class="flex items-center gap-2 mb-4"
            [ngClass]="{
              'text-white': !isPlatinumTheme,
              'text-dc-navy': isPlatinumTheme,
            }"
            href="https://04.gov.ae"
            target="_blank"
            rel="noopener noreferrer"
            [attr.data-label]="'VOICE_MATTERS' | translate"
          >
            <img [src]="getIconPath('svg/voice-matter.svg')" />
            <span class="label">{{ "VOICE_MATTERS" | translate }}</span>
          </a>
        }

        <!-- Collapse button -->
        <a
          (click)="collapsed = !collapsed; toggleSidebar()"
          class="flex items-center gap-2 text-white"
          [attr.data-label]="'EXPAND_NAVIGATION' | translate"
        >
          <!-- <i
          class="fas fa-angle-left w-4 h-4 transition-transform"
          [class.rotate-180]="collapsed"
        ></i> -->
          <img
            [src]="getIconPath('svg/chevron-left.svg')"
            class="transition-transform"
            [class.rotate-180]="collapsed"
          />
          <span class="label">{{ "COLLAPSE_NAVIGATION" | translate }}</span>
        </a>
      </div>
    </div>
  </aside>

  <!-- Mobile overlay sidebar -->
  <!-- Backdrop -->
  @if (open) {
    <div
      class="lg:hidden fixed inset-0 z-40 bg-black/40 transition-opacity duration-300"
      [class.opacity-0]="!open"
      [class.opacity-100]="open"
      (click)="close.emit()"
    ></div>
  }
  <!-- Sliding panel -->
  <aside
    class="lg:hidden sidebar fixed inset-y-0 z-50 w-56 shadow-xl transform transition-transform duration-200 flex flex-col"
    [ngClass]="{
      'platinum-mobile': isPlatinumTheme,
      'bg-dc-navy': !isPlatinumTheme,
    }"
    [class.left-0]="!isRtl"
    [class.right-0]="isRtl"
    [class.-translate-x-full]="!open && !isRtl"
    [class.translate-x-full]="!open && isRtl"
    [class.translate-x-0]="open"
    aria-label="Mobile Sidebar"
  >
    <div
      class="h-16 flex items-center px-4 border-b"
      [ngClass]="{
        'border-b-white': !isPlatinumTheme,
        'border-b-gray-300': isPlatinumTheme,
      }"
    >
      <span
        class="font-semibold"
        [ngClass]="{
          'text-white': !isPlatinumTheme,
          'text-dc-navy': isPlatinumTheme,
        }"
      >
        <img
          [src]="isPlatinumTheme ? '/images/logo-navy.png' : '/images/logo.png'"
          alt="Logo"
          class=""
        />
      </span>
      <button
        class="ml-auto p-2"
        (click)="close.emit()"
        aria-label="Close sidebar"
      >
        <img
          [src]="
            isPlatinumTheme
              ? '/icons/svg/angle-right.svg'
              : '/icons/svg/back.svg'
          "
          alt="back"
          class="transition-transform"
          [ngClass]="isPlatinumTheme ? 'rotate-180' : 'rtl:rotate-180'"
        />
      </button>
    </div>

    <div class="bg-pattern flex flex-col flex-1 overflow-y-auto">
      <ul class="flex-1" id="sidebar">
        @for (menu of menus; track menu) {
          @if (menu.active) {
            <li
              routerLinkActive="active-menu"
              routerLinkActive="active-menu"
              [routerLinkActiveOptions]="{ exact: false }"
            >
              <a
                [routerLink]="menu.key === 'MENU_BUSINESS_GROUP' ? null : '/' + menu.route"
                class="side-menu-item menu-text-icon flex items-center"
                (click)="collapseSidebar(menu.key, $event)"
              >
                <img [src]="getIconPath(menu.icon)" class="ltr:mr-2 rtl:ml-2" />
                <span class="label">{{ menu.key | translate }}</span>
              </a>
            </li>
          }
        }
      </ul>

      <!-- bottom-fixed block -->
      <div
        class="mt-auto border-t border-white/10 px-5 py-4 text-white text-sm"
      >
        <!-- Chat link -->
        @if (flags.chatEnabled) {
          <a
            class="flex items-center gap-2 mb-4"
            [ngClass]="{
              'text-white': !isPlatinumTheme,
              'text-dc-navy': isPlatinumTheme,
            }"
            (click)="onChatWithUs($event)"
          >
            <img [src]="getIconPath('svg/comment.svg')" />
            <span class="label">{{ "CHAT_WITH_US" | translate }}</span>
          </a>
          <a
            class="flex items-center gap-2 mb-4"
            href="https://wa.me/9718002426237"
            target="_blank"
            rel="noopener noreferrer"
            [attr.data-label]="'CHAT_ON_WHATSAPP' | translate"
          >
            <img [src]="getIconPath('svg/whatsapp.svg')" width="24" />
            <span class="label">{{ "CHAT_ON_WHATSAPP" | translate }}</span>
          </a>

          <a
            class="flex items-center gap-2 mb-4"
            [ngClass]="{
              'text-white': !isPlatinumTheme,
              'text-dc-navy': isPlatinumTheme,
            }"
            href="https://04.gov.ae"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img [src]="getIconPath('svg/voice-matter.svg')" />
            <span class="label">{{ "VOICE_MATTERS" | translate }}</span>
          </a>
        }

        <!-- Collapse button -->
        <button
          type="button"
          (click)="close.emit()"
          class="flex items-center gap-2"
          [ngClass]="{
            'text-white': !isPlatinumTheme,
            'text-dc-navy': isPlatinumTheme,
          }"
        >
          <img
            [src]="getIconPath('svg/chevron-left.svg')"
            class="transition-transform rtl:rotate-180"
          />
          <span class="label">{{ "COLLAPSE_NAVIGATION" | translate }}</span>
        </button>
      </div>
    </div>
  </aside>
</div>

@if (showBusinessGroupRedirectModal) {
<div class="dc-modal">
  <div class="dc-modal-container bg-white! w-[92%]! max-w-[520px]! p-0! overflow-hidden">
    <button
      type="button"
      class="modal-x-button text-gray-500!"
      (click)="closeBusinessGroupRedirectModal()"
      aria-label="Close"
    >
      <i class="fas fa-close"></i>
    </button>
    <div class="px-6 pt-8 pb-6 text-center">
      <h2 class="text-dc-navy text-xl font-bold mb-3">
        {{ "BUSINESS_GROUP_REDIRECT.TITLE" | translate }}
      </h2>
      <p class="text-dc-navy! text-xl mb-2">
        {{ "BUSINESS_GROUP_REDIRECT.MESSAGE" | translate }}
      </p>
      <p class="text-gray-600! text-lg mb-2">
        {{ "BUSINESS_GROUP_REDIRECT.REDIRECTING_IN" | translate : { seconds: redirectCountdownSeconds } }}
      </p>
      <!-- <p class="text-dc-navy! text-3xl font-semibold mb-6">
        {{ "BUSINESS_GROUP_REDIRECT.PLATFORM" | translate }}
      </p> -->

      <div class="mt-4">
        <app-button
        [label]="'BUSINESS_GROUP_REDIRECT.PROCEED' | translate"
        classesName="btn-edge-cut"
        (onBtnClick)="redirectBusinessGroup()"
      ></app-button>
      </div> 
    </div>
  </div>
</div>
}
